import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild
} from "@angular/core";
import { BehaviorSubject, fromEvent, Subject } from "rxjs";
import { concatMap, filter, switchMap, takeUntil, tap } from "rxjs/operators";
import { ExtendedMediaStream, mapStreamToVideo } from "youm-lib";

@Component({
  selector: "app-plain-video",
  templateUrl: "./plain-video.component.html",
  styleUrls: ["plain-video.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlainVideoComponent implements AfterViewInit, OnDestroy {
  @ViewChild("videoRef") _videoRef!: ElementRef<HTMLVideoElement>;

  @Input() set stream(value: null | ExtendedMediaStream) {
    this._stream$.next(value);
  }

  private readonly _stream$ = new BehaviorSubject<null | ExtendedMediaStream>(
    null
  );
  private readonly _destroy$ = new Subject<void>();

  ngAfterViewInit() {
    const video = this._videoRef.nativeElement;

    // In order to handle
    // AbortError: The play() request was interrupted by a new load request.
    // for the stream without the video track
    fromEvent(video, "canplay")
      .pipe(
        concatMap(() => video.play()),
        takeUntil(this._destroy$)
      )
      .subscribe();

    this._stream$
      .pipe(
        filter((_): _ is ExtendedMediaStream => !!_),
        switchMap((stream) =>
          mapStreamToVideo(stream, video).pipe(
            // 'load' call fires the 'canplay' event
            tap(() => video.load())
          )
        ),
        takeUntil(this._destroy$)
      )
      .subscribe((_) => _);
  }

  ngOnDestroy() {
    const video = this._videoRef.nativeElement;

    this._destroy$.next();
    this._destroy$.complete();

    video.pause();
    video.srcObject = null;
    video.load();
  }
}
